export default class FoxentryValidation {
	formElement = null;

	constructor(element) {
		this.formElement = element;
	}

	validate(onSuccess, onFailed) {
		const Foxentry = window.Foxentry;
		let currentInterval = null;

		currentInterval = setInterval(() => {
			const validationInProgress = Foxentry.validationInProgress();

			if (!validationInProgress) {
				const foxentryValidation = Foxentry.formValidation(this.formElement);

				if (foxentryValidation?.valid) {
					clearInterval(currentInterval);
					currentInterval = null;

					if (onSuccess) {
						onSuccess();
					}
				} else {
					clearInterval(currentInterval);
					currentInterval = null;

					if (onFailed) {
						onFailed();
					}
				}
			}
		}, 1000);
	}
}
